import { createStyles, Title, Text, Container, rem } from "@mantine/core";
import { Dots } from "./Dots";

const useStyles = createStyles((theme) => ({
  wrapper: {
    position: "relative",
    paddingTop: rem(120),
    paddingBottom: rem(80),

    [theme.fn.smallerThan("sm")]: {
      paddingTop: rem(80),
      paddingBottom: rem(60),
    },
  },

  inner: {
    position: "relative",
    zIndex: 1,
  },

  dots: {
    position: "absolute",
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[5]
        : theme.colors.gray[1],

    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },

  dotsLeft: {
    left: 0,
    top: 0,
  },

  title: {
    textAlign: "center",
    fontWeight: 800,
    fontSize: rem(40),
    letterSpacing: -1,
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    marginBottom: theme.spacing.xs,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,

    [theme.fn.smallerThan("xs")]: {
      fontSize: rem(28),
      textAlign: "left",
    },
  },

  highlight: {
    color:
      theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 4 : 6],
  },

  description: {
    textAlign: "center",

    [theme.fn.smallerThan("xs")]: {
      textAlign: "left",
      fontSize: theme.fontSizes.md,
    },
  },

  controls: {
    marginTop: theme.spacing.lg,
    display: "flex",
    justifyContent: "center",

    [theme.fn.smallerThan("xs")]: {
      flexDirection: "column",
    },
  },

  control: {
    "&:not(:first-of-type)": {
      marginLeft: theme.spacing.md,
    },

    [theme.fn.smallerThan("xs")]: {
      height: rem(42),
      fontSize: theme.fontSizes.md,

      "&:not(:first-of-type)": {
        marginTop: theme.spacing.md,
        marginLeft: 0,
      },
    },
  },
}));

export function Hero() {
  const { classes } = useStyles();

  return (
    <div className={classes.wrapper}>
      <Dots className={classes.dots} style={{ left: 0, top: 0 }} />
      <Dots className={classes.dots} style={{ left: 60, top: 0 }} />
      <Dots className={classes.dots} style={{ left: 0, top: 140 }} />
      <Dots className={classes.dots} style={{ right: 0, top: 60 }} />

      <Container className={classes.inner}>
        <Title fw={400} className={classes.title}>
          Find unique{" "}
          <Text
            fw={900}
            component="span"
            variant="gradient"
            gradient={{ from: "#FF00E5", to: "#AD00FF", deg: 45 }}
            inherit
          >
            gift ideas
          </Text>{" "}
          using the power of{" "}
          <Text
            fw={900}
            component="span"
            variant="gradient"
            gradient={{ from: "#0085FF", to: "#19C5DC", deg: 45 }}
            inherit
          >
            GPT
          </Text>
        </Title>

        <Container p={0} mt="xl" size={600}>
          <Text size="lg" color="dimmed" className={classes.description}>
            Find the perfect gift for your friend, family or colleague using the
            GPT assistant. This tool allows you to easily search for gifts using
            the GPT model which is enriched using content from over the whole
            internet! You’ll never have to stress finding a gift for a birthday
            again!
          </Text>
        </Container>
      </Container>
    </div>
  );
}
